import SeffoLogo from "../images/seffo-logo.webp";

export { SeffoLogo };

// A logo value is only usable when it is a non-empty string. Older builds wrote
// undefined/null straight into localStorage, which stores them as text.
const isUsableLogo = (logo) =>
  typeof logo === "string" &&
  logo.trim() !== "" &&
  logo !== "undefined" &&
  logo !== "null";

// Persist the site logo, falling back to the Seffo logo when none is configured
export const setStoredLogo = (companyLogo) => {
  const logo = isUsableLogo(companyLogo) ? companyLogo : SeffoLogo;
  localStorage.setItem("logo", logo);
  return logo;
};

// Read the logo to render; never returns an unusable value
export const getStoredLogo = () => {
  const logo = localStorage.getItem("logo");
  return isUsableLogo(logo) ? logo : SeffoLogo;
};

// True only when a real logo has already been fetched and stored
export const hasStoredLogo = () => isUsableLogo(localStorage.getItem("logo"));
